import React from 'react'
import { tr } from 'pmt-modules/i18n'
import PropTypes from 'prop-types'
import { withTheme } from 'pmt-ui/styles'

function ThemeDefault(props) {
  const {
    theme: { id, ...theme },
  } = props

  return (
    <pre>
      {tr('registration.form.register.accept_cgu', {
        context: `testContext`,
        desc: 'test',
        fr: "J'accepte les CGU",
      })}
      {JSON.stringify(theme, null, 2)}
    </pre>
  )
}

ThemeDefault.propTypes = {
  theme: PropTypes.object.isRequired,
}

export default withTheme(ThemeDefault)
